
const themes = {
    primary: 'btn-primary',
    info: 'btn-primary',
    success: 'btn-success',
    danger: 'btn-danger',
    lightDanger: 'btn-light-danger',
    lightPrimary: 'btn-light-primary',
    warning: 'btn-warning',
    secondary: 'btn-secondary',
    light: 'btn-light',
};

const selectedThemes = {
    primary: 'btn-primary',
    info: 'btn-primary',
    success: 'btn-success-selected',
    danger: 'btn-danger-selected',
    lightDanger: 'btn-light-danger-selected',
    lightPrimary: 'btn-light-primary-selected',
    warning: 'btn-warning-selected',
    secondary: 'btn-secondary-selected',
    light: 'btn-light-selected',
};

const bgs = {
    primary: 'dark',
    info: 'dark',
    success: 'dark',
    danger: 'dark',
    lightDanger: 'light',
    lightPrimary: 'light',
    warning: 'dark',
    secondary: 'dark',
    light: 'light',
};

const sizes = {
    sm: {
        classes: 'px-2 py-1 text-xs',
        iconSize: '0.5x',
    },
    md: {
        classes: 'px-3 pt-2 pb-2 text-sm',
        iconSize: '1x',
    }
}

export {
    themes,
    selectedThemes,
    bgs,
    sizes,
};
